import React from 'react';

export class ErrorBoundary extends React.Component {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    window.Sentry.withScope((scope) => {
      scope.setTag('errorBoundaryError', 'true');
      scope.setExtra('componentStack', errorInfo);

      window.Sentry.captureException(error);
    });
  }

  render() {
    return this.props.children;
  }
}
